import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0]?.id ?? null);

  return (
    <section id="faq" className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[320px_1fr] lg:gap-12">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <span className="text-xs font-medium tracking-widest text-accent-700">常见问题</span>
          <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            关于黑料入口导航站，你可能想问
          </h2>
          <p className="mt-3 text-sm leading-6 text-foreground-700">
            排序规则、整理方式、可用性校验都写在这里。点标题展开，再点一次收起。
          </p>
          <div className="mt-5 flex items-center gap-2 rounded-md border border-background-200 bg-background-50 p-3">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-refresh-line text-base" />
            </span>
            <p className="text-xs leading-5 text-foreground-600">推荐与榜单每天整理，合集与归档按周回看一次。</p>
          </div>
        </div>

        <div className="flex flex-col gap-2.5">
          {faqItems.map((item) => {
            const isOpen = item.id === openId;
            return (
              <div
                key={item.id}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line text-sm" : "ri-add-line text-sm"} />
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-background-200/70 px-4 py-4 text-sm leading-7 text-foreground-700 md:px-5">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}